// Puntuación por semana para el «Informe del vehículo» (puro, con test).
//
// Mapon la da mes a mes; aquí el informe lee a lo más 31 días de puntos
// crudos, así que se parte por semana (lunes a domingo, hora local).
// shortcut: por semana dentro del periodo; la histórica mes a mes llega con la
// calificación precalculada en daily_unit_summaries (fase 2 de Comportamiento).
import { scoreDriving, type ScorePoint, type ScoreSettings } from "./drivingScore";

const DAY_MS = 86_400_000;

/** Lunes 00:00 local de la semana de `ts`. */
export const weekStart = (ts: number): number => {
  const d = new Date(ts);
  d.setHours(0, 0, 0, 0);
  const dow = (d.getDay() + 6) % 7; // lunes = 0
  return d.getTime() - dow * DAY_MS;
};

export const scoreByWeek = (points: ScorePoint[], settings: ScoreSettings): { start: number; overall: number | null; drivingMs: number }[] => {
  const byWeek = new Map<number, ScorePoint[]>();
  for (const p of points) {
    const k = weekStart(p.ts);
    const arr = byWeek.get(k) ?? [];
    arr.push(p);
    byWeek.set(k, arr);
  }
  return [...byWeek.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([start, pts]) => {
      const s = scoreDriving(pts, settings);
      return { start, overall: s.overall, drivingMs: s.drivingMs };
    });
};
